import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { commonReducers } from '@qcdoc/shared/services/auth/bootstrap.ts';
import { lookupsReducer } from '@qcdoc/shared/redux/slices/lookupsSlice.ts';
import { sessionReducer } from '@qcdoc/shared/redux/sessionReducer.ts';
import { vendorIdentityReducer as vendorIdentity } from '../slices/vendorIdentitySlice.ts';
import vendorCoa from '../slices/vendorCoaSlice.ts';
import vendorVqca from '../slices/vendorVqcaSlice.ts';
import vendorDashboard from '../slices/vendorDashboardSlice.ts';
import { vendorPackagingReducer as vendorPackaging } from '../slices/vendorPackagingSlice.ts';

export const vendorReducers = { vendorIdentity, vendorCoa, vendorVqca, vendorPackaging, vendorDashboard };
const rootReducer = combineReducers({ ...commonReducers, lookups: lookupsReducer, ...vendorReducers });

export const createAppStore = () => configureStore({
  reducer: sessionReducer<ReturnType<typeof rootReducer>>(rootReducer),
  devTools: false,
});

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];